import React, { useState } from 'react';
import { ListGroup, ListGroupItem, Collapse, Row, Col, Card, CardBody, CardTitle } from 'reactstrap';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const IitemBranch = ({headers,node, rightSon = 0,actionOnClick = ()=>{} }: any) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const iconItemTree = () => {
        if (node.children) {
            return isOpen ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />;
        } else {
            return '';
        }
    };

    const itemTypeIcon = (packageName: string) => {
        if (packageName == 'Pallet' || packageName == 'PALLETS') {
            return <i className="fas fa-pallet iconTransportShipment fa-lg"></i>;
        } else if (packageName == 'Box') {
            return <i className="fas fa-box iconTransportShipment fa-lg"> </i>;
        }
        else if (packageName == 'Pieces') {
            return <i className="mdi mdi-widgets iconTransportShipment fa-xl"> </i>;
        }
        else if (packageName && (packageName.startsWith('20') || packageName.startsWith('40'))) {
            return  <i className="mdi mdi-cube iconTransportShipment fa-lg"></i> ;
        } else {
            return <i className="fas fa-box-open iconTransportShipment fa-lg"> </i>;
        }
    };



    const funtioOnClickRow = ()=>{
        toggle();
        if(actionOnClick){
            actionOnClick(node.obj)
        }
    }
    return (
        <>
            <ListGroupItem
                style={{
                    cursor: 'pointer',
                    marginLeft: `${rightSon}px`,
                    padding: 0,
                    overflowX: 'visible',
                    minWidth: 'max-content',
                }}
                onClick={funtioOnClickRow}
            >
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${headers.length + 1}, 1fr)`,
                        alignItems: 'center',
                        textAlign: 'center',
                    }}
                >
                    <div style={{ width: '150px' }} className="d-flex flex-column justify-content-center align-items-center">
                        {itemTypeIcon(node.packageName)}
                        {iconItemTree()}
                    </div>
                    {node.obj && headers &&
                        headers.map((header: any, index: number) => {
                            const data = node.obj[header.dataField];
                            return (
                                <div style={{ width: '150px' }} key={`${data}-${header.dataField}-${index}-dataTable`}>
                                    <p>{data != null && data != undefined && data != "Invalid date" ? data.toString() : ''}</p>
                                </div>
                            );
                        })}
                </div>
            </ListGroupItem>
            {Array.isArray(node.children) && (
                <Collapse isOpen={isOpen}>
                    <ListGroup>
                        {node.children.map((child: any) => (
                            <IitemBranch headers={headers} rightSon={15 + rightSon} key={child.id} node={child} />
                        ))}
                    </ListGroup>
                </Collapse>
            )}
        </>
    );
};

export default IitemBranch;
